import React from 'react';
import times from 'lodash/times';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableTitle,
  TableWrapper,
} from '../../../../../../CommonComponents/OPL/Table/Table';

interface Props {
  isWorkflow: boolean;
}

export const LoadingTable = ({ isWorkflow }: Props) => {
  return (
    <TableWrapper mt="24" variant={isWorkflow ? 'bordered' : undefined}>
      <TableTitle>
        <Shimmer width="50%" height="32px" />
      </TableTitle>
      <TableHeader>
        <TableRow pl="32">
          <TableCell width="50%">
            <Shimmer width="100%" height="32px" />
          </TableCell>
          <TableCell width="23%">
            <Shimmer width="100%" height="32px" />
          </TableCell>
          <TableCell width="19%">
            <Shimmer width="100%" height="32px" />
          </TableCell>
          <TableCell width="8%" />
        </TableRow>
      </TableHeader>
      <TableBody>
        {times(3).map(i => (
          <TableRow key={i}>
            <TableCell width="50%">
              <Shimmer width="100%" height="32px" />
            </TableCell>
            <TableCell width="25%">
              <Shimmer width="100%" height="32px" />
            </TableCell>
            <TableCell width="19%">
              <Shimmer width="100%" height="32px" />
            </TableCell>
            <TableCell width="6%">
              <Shimmer width="100%" height="32px" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableWrapper>
  );
};
